import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { errorMessage } from "@/lib/api";
import { Spinner } from "./States";

// Sensitive actions: explicit confirmation + mandatory reason (min 5 chars), sent to backend for audit.
export const ConfirmReasonDialog = ({ open, onOpenChange, title, description, confirmLabel, onConfirm, danger, children, testId }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const change = (o) => {
    if (!o) {
      setReason("");
      setErr("");
    }
    onOpenChange(o);
  };

  const submit = async () => {
    if (reason.trim().length < 5) return setErr("Alasan wajib diisi, minimal 5 karakter.");
    setBusy(true);
    setErr("");
    try {
      await onConfirm(reason.trim());
      setReason("");
      onOpenChange(false);
    } catch (e) {
      setErr(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={change}>
      <DialogContent data-testid={testId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <div className="space-y-2">
          <Label htmlFor="confirm-reason">Alasan (wajib, tercatat di audit)</Label>
          <Textarea id="confirm-reason" value={reason} onChange={(e) => setReason(e.target.value)}
            placeholder="Tuliskan alasan tindakan ini" data-testid="confirm-reason-input" />
          {err && <p className="text-sm text-[#E11D2E]" role="alert" data-testid="confirm-error">{err}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => change(false)} data-testid="confirm-cancel-button">Batal</Button>
          <Button onClick={submit} disabled={busy} variant={danger ? "destructive" : "default"} data-testid="confirm-submit-button">
            {busy && <Spinner />} {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
